import React from 'react';
import { useState, useEffect } from 'react';
//import './buyerszonecss.css';
import './buyerszonecss.css';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { Link } from 'react-router-dom';
import { getMethod } from '../../../services/apiService';
import LoadingSpinner from '../../../utility/LoadingSpinner';

function Paintingsbuycard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [latestEntry, setLatestEntry] = useState(null);
  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMethod(`paintings-all`);
        console.log("table data=======", response)
        if (response.status && response.data) {
          console.log("inside if========",response.log)
          setData(response.data);
        } else {
          console.error("Failed to fetch paintings:", response.error || response);
        }
      } catch (error) {
        console.error("Error fetching paintings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  //Display welcome content - GET
  useEffect(() => {
    const getWelcome = async () => {
      try {
        const response = await getMethod('welcome');
        if (!response.error && response.data) {
          const data = response.data;
          // console.log("dataaaaaaaa0", data)
          if (Array.isArray(data) && data.length > 0) {
            const lastItem = data[data.length - 1];
            setLatestEntry(lastItem);
            localStorage.setItem('welcomeContent', lastItem);
          } else if (data.title && data.description) {
            setLatestEntry(data);
            localStorage.setItem('welcomeContent', data);
          }
        } else {
          const storedContent = localStorage.getItem('welcomeContent');
          if (storedContent) {
            setLatestEntry(storedContent);
          }
        }
      } catch (error) {
        console.error('Error fetching welcome content:', error);
        const storedContent = localStorage.getItem('welcomeContent');
        if (storedContent) {
          setLatestEntry(storedContent);
        }
      }
    };

    getWelcome();
  }, []);

  //react-table
  const columns = [
    {
      header: "S.No",
      id: "serial_number",
      cell: ({ row }) => (
        <Link to={`/painting/${row.original.id}`}>
          {row.original.serial_number || row.original.id}
        </Link>
      ),
    },
    {
      header: "Title",
      accessorKey: "title",
      cell: ({ getValue }) => (
        <div dangerouslySetInnerHTML={{ __html: getValue() }} />
      ),
    },
    {
      header: "Price (INR)",
      accessorKey: "price",
    },
    {
      header: "Sold Order",
      accessorKey: "sold_order",
    },
    {
      header: "Brought by",
      accessorKey: "brought_by",
    },

  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="table-container-div">
      <div className="table-container">
        {loading ? (
          <LoadingSpinner />
        ) : data.length > 0 ? (
          <table className="table table-striped table-bordered">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.id}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center" }}>No paintings available.</p>
        )}
      </div>
      <div className="paintingbuycarddescription"
        dangerouslySetInnerHTML={{ __html: latestEntry?.buyerszone_painting_description ?? '' }} />
    </div>
  );

}

export default Paintingsbuycard;